import { AddEdit } from '../../../../interfaces/template.interface';
import { Validation } from '../../../../interfaces/common';
import { VALIDATION_FIELD_MAPPING } from '../../../../utils/appConstant';
import { Regex } from '../../../../utils/appConstant';
import translate from '../../../../i18n/config';

export const validateAddEditForm = (formData: AddEdit, fieldName?: string): Validation => {
  let validation: Validation = { validate: true, fields: [] };

  if (!fieldName || fieldName === VALIDATION_FIELD_MAPPING.name) {
    if (!formData.name?.trim()) {
      validation.validate = false;
      validation.fields.push({
        field: VALIDATION_FIELD_MAPPING.name,
        message: translate.t('templates.addEdit.pageTexts.form.name.errors.required'),
      });
    }
  }

  if (!fieldName || fieldName === VALIDATION_FIELD_MAPPING.code) {
    if (!formData.code?.trim()) {
      validation.validate = false;
      validation.fields.push({
        field: VALIDATION_FIELD_MAPPING.code,
        message: translate.t('templates.addEdit.pageTexts.form.code.errors.required'),
      });
    } else if (!Regex.code.test(formData.code.trim())) {
      validation.validate = false;
      validation.fields.push({
        field: VALIDATION_FIELD_MAPPING.code,
        message: translate.t('templates.addEdit.pageTexts.form.code.errors.format'),
      });
    }
  }

  if (!fieldName || fieldName === VALIDATION_FIELD_MAPPING.description) {
    if (!formData.description?.trim()) {
      validation.validate = false;
      validation.fields.push({
        field: VALIDATION_FIELD_MAPPING.description,
        message: translate.t('templates.addEdit.pageTexts.form.description.errors.required'),
      });
    }
  }

  if (!fieldName || fieldName === VALIDATION_FIELD_MAPPING.status) {
    if (formData.status === '' || formData.status === undefined || formData.status === null) {
      validation.validate = false;
      validation.fields.push({
        field: VALIDATION_FIELD_MAPPING.status,
        message: translate.t('templates.addEdit.pageTexts.form.status.errors.required'),
      });
    }
  }

  if (!fieldName || fieldName === VALIDATION_FIELD_MAPPING.fileType) {
    if (!formData.fileType) {
      validation.validate = false;
      validation.fields.push({
        field: VALIDATION_FIELD_MAPPING.fileType,
        message: translate.t('templates.addEdit.pageTexts.form.fileType.errors.required'),
      });
    }
  }



  return validation;
};

export const validateHeaderMappingForm = (mappings: any[], mappingId?: number): Validation => {
  let validation: Validation = { validate: true, fields: [] };

  mappings.forEach((mapping) => {
    // Only validate if mappingId is not provided (validating all) OR matches current mappingId
    if (!mappingId || mapping.id === mappingId) {
      // Only validate if row is checked
      if (mapping.isChecked) {
        if (!mapping.mapping?.trim()) {
          validation.validate = false;
          validation.fields.push({
            field: `${VALIDATION_FIELD_MAPPING.textboxMapping}-${mapping.id}`,
            message: translate.t('templates.addEdit.pageTexts.form.textboxMapping.errors.required'),
          });
        }
      }
    }
  });

  return validation;
};
